module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número de alunos de graduação participantes",
      "value": this.projetoPesquisa.numAlunosGraduacao ? this.projetoPesquisa.numAlunosGraduacao : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número de alunos de especialização participantes",
      "value": this.projetoPesquisa.numAlunosEspecializacao ? this.projetoPesquisa.numAlunosEspecializacao : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Possui vínculo com a iniciação científica",
      "value": this.projetoPesquisa.vinculoIniciacaoCientifica != null ? (this.projetoPesquisa.vinculoIniciacaoCientifica ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Possui interface com outras áreas",
      "value": this.projetoPesquisa.interfaceOutrasAreas != null ? (this.projetoPesquisa.interfaceOutrasAreas ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Áreas de interface com o projeto")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true && _vm.projetoPesquisa.areaDesenvTec === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "black--text body-1"
  }, [_vm._v("• Desenvolvimento Tecnológico")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true && _vm.projetoPesquisa.areaEnsino === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "black--text body-1"
  }, [_vm._v("• Ensino")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true && _vm.projetoPesquisa.areaExtensao === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "black--text body-1"
  }, [_vm._v("• Extensão")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true && _vm.projetoPesquisa.areaOutros === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "black--text body-1"
  }, [_vm._v("• " + _vm._s(_vm.projetoPesquisa.especAreaOutros))])])], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEditar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6910ca28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/outras-informacoes.vue
// module id = 866
// module chunks = 0